import React from "react";
import {
  Box,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  Dialog
} from "@mui/material";
import { styled } from "@mui/system";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import ButtonCta1 from "../button/ButtonCta1";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 12,
  },
}));

const labelStyle = {
  fontSize: "14px",
  marginBottom: "8px",
  fontWeight: 500,
  color: "#333",
};

const requiredAr = {
  color: "red",
  marginLeft: "4px",
};

const SwitchEnvDialog = ({
  open,
  onClose,
  onConfirm,
  organizationOptions = [],
  organization,
  setOrganization,
  getOrgLabel,
  handleInputFocus,
  title = "Switch Environment",
  subTitle = "Please select the environment you want to access.",
  leftButtonText = "Cancel",
  rightButtonText = "Switch",
}) => {
  const handleChange = (e, value) => {
    if (value === null) {
      value = {
        environmentId: "",
        environmentName: "",
      };
    }
    setOrganization(value);
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          color: "#a50218",
          fontFamily: "Montserrat",
          padding: "32px 32px 12px 32px",
          fontWeight: 600,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ minWidth: "600px", padding: "20px 32px" }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontSize: "14px", fontFamily: "Montserrat", fontWeight: 500 }}
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
        <Box sx={{ display: "flex", flexDirection: "column", mt: 3 }}>
          <label style={labelStyle}>
            Environment
          </label>
          <CustomAutocomplete
            options={organizationOptions}
            value={organization}
            onChange={handleChange}
            getOptionLabel={getOrgLabel}
            onFocus={handleInputFocus}
            placeholder="Select environment..."
          />
        </Box>
        <Divider sx={{ height: "0.5px", marginTop: "20px" }} />
      </DialogContent>

      <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
        <Box>
          <ButtonCta1
            text={leftButtonText}
            variant="contained"
            onClick={onClose}
            bgColor="#e0e0e0"
            color="#5a5a5a"
          />
        </Box>
        <Box style={{ marginLeft: "20px" }}>
          <ButtonCta1
            text={rightButtonText}
            variant="contained"
            onClick={onConfirm}
            autoFocus
            bgColor="#a50218"
            color="#fff"
            disabled={!organization?.environmentId}
          />
        </Box>
      </DialogActions>
    </CustomDialog>
  );
};

export default SwitchEnvDialog;
